module.exports = __webpack_public_path__ + "img/_6.1905c9b3.png";